import { upload } from '../services/modules/upload/upload.repository';

export enum UploadMultipleFilesOutputStatusEnum {
  ERROR = 'error',
  SUCCESS = 'success',
}

export interface UploadMultipleFilesOutput {
  file: File;
  status: UploadMultipleFilesOutputStatusEnum;
  url?: string;
}

const useMultipleFileUploads = () => {
  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file as File);

    const response = await upload(formData);

    if (!response.ok || !response.data) {
      return;
    }

    return response.data.url;
  };

  const uploadMultipleFiles = async (files: File[]): Promise<UploadMultipleFilesOutput[]> => {
    const allFilesResult = await Promise.all(
      files.map(async (file) => {
        const url = await uploadFile(file);

        if (!url) {
          return {
            file,
            status: UploadMultipleFilesOutputStatusEnum.ERROR,
          };
        }

        return {
          url,
          file,
          status: UploadMultipleFilesOutputStatusEnum.SUCCESS,
        };
      }),
    );

    return allFilesResult;
  };

  return {
    uploadMultipleFiles,
  };
};

export default useMultipleFileUploads;
